// Auto-generated translation for el.
// Source: landings.js, translated via Claude Sonnet on 2026-05-26T11:28:31.657607+00:00.

export const LANDINGS = {
  "eigen-paard": {
    slug: "eigen-paard",
    eyebrow: "Για ιδιοκτήτες αλόγων",
    title: "Όλα για το άλογό σου. Σε μία εφαρμογή.",
    subtitle: "Διαχειρίσου υγεία, προπόνηση, προγραμματισμό και επαγγελματίες από έναν ολοκληρωμένο φάκελο.",
    primaryCTA: {
      label: "Ξεκίνα δωρεάν",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Δες το Premium",
      href: "/premium",
    },
    heroScreenshot: {
      url: "/assets/owner-horse.png",
      alt: "Προφίλ αλόγου — βάρος, εμβολιασμός, EquiCoach, διατροφή και προπόνηση σε μία οθόνη",
      caption: "Το άλογό σου, πλήρως στην εικόνα.",
    },
    problem: "Πιθανότατα κρατάς ραντεβού, φωτογραφίες, προπόνηση, διατροφή και υγεία διασκορπισμένα — σε ομάδες WhatsApp, χαρτόκουτα και ξεχωριστές εφαρμογές. Έτσι χάνεις την επισκόπηση.",
    solution: "Το EquiSight μετατρέπει το άλογό σου σε έναν πλήρη ψηφιακό φάκελο που σε συνοδεύει παντού.",
    benefits: [
      "Ένα πλήρες προφίλ ανά άλογο",
      "Υγεία, πεταλωτής, οδοντίατρος και φυσιοθεραπευτής σε ένα μέρος",
      "Ημερολόγιο με έξυπνες υπενθυμίσεις",
      "Φωτογραφίες, σημειώσεις και ιστορικό χωρίς όριο",
      "Αντίγραφο ασφαλείας όλων των δεδομένων σου με το Premium",
    ],
    pricing: {
      tiers: [
        {
          name: "Basic",
          price: "€0",
          note: "1 άλογο · πάντα δωρεάν",
        },
        {
          name: "Premium",
          price: "€4,99",
          note: "Πολλαπλά άλογα + αντίγραφο ασφαλείας",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Έτοιμος να ξεκινήσεις;",
      title: "Ξεκίνα σήμερα με το πρώτο σου άλογο.",
      href: "/#waitlist",
    },
  },
  "premium": {
    slug: "premium",
    eyebrow: "Premium",
    title: "Περισσότερα άλογα. Περισσότερη επισκόπηση. Περισσότερη σιγουριά.",
    subtitle: "Αναβαθμίστε στο Premium και διαχειριστείτε όλα τα άλογά σας χωρίς περιορισμούς — με πλήρη EquiCoach intelligence.",
    primaryCTA: {
      label: "Ξεκινήστε 14 ημέρες δωρεάν",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Όλες οι τιμές",
      href: "/#pricing",
    },
    audience: "Για ιδιοκτήτες, αθλητές ιππασίας και κτηνοτρόφους με πολλαπλά άλογα.",
    features: [
      "Απεριόριστη προσθήκη αλόγων",
      "Πλήρες ιστορικό ανά άλογο",
      "Δημιουργία αντιγράφων ασφαλείας δεδομένων",
      "Εκτεταμένες αναλύσεις EquiCoach",
      "Έξυπνες ειδοποιήσεις και προγραμματισμός",
      "Υγεία και εκπαίδευση πλήρως συνδεδεμένα",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "Λιγότερο από €0,17 την ημέρα",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Έτοιμοι;",
      title: "Αναβαθμίστε στο Premium.",
      href: "/#waitlist",
    },
  },
  "manege-ruiter": {
    slug: "manege-ruiter",
    eyebrow: "Για ιππείς ιππόδρομου",
    title: "Να βελτιώνεσαι, ακόμα και χωρίς δικό σου άλογο.",
    subtitle: "Παρακολούθησε τα μαθήματα, τις προπονήσεις και την εξέλιξή σου μέσα στο EquiSight — για λιγότερο από έναν καφέ το μήνα για μαμά ή μπαμπά. Ή ένα νόστιμο παγωτό με σαντιγί.",
    primaryCTA: {
      label: "Ξεκίνα με Premium",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Πώς λειτουργεί;",
      href: "#features",
    },
    problem: "Ως ιππέας ιππόδρομου συχνά δεν έχεις δικό σου άλογο, αλλά θέλεις να εξελίσσεσαι και να έχεις επισκόπηση των μαθημάτων, των στόχων και των αλόγων που ιππεύεις.",
    solution: "Η λειτουργικότητα ιππόδρομου περιλαμβάνεται στο Premium — παρακολούθησε τη δική σου εξέλιξη και δες τα συνδεδεμένα άλογα του ιππόδρομου σε λειτουργία μόνο ανάγνωσης.",
    features: [
      "Καταγραφή προπονήσεων",
      "Ορισμός στόχων",
      "Παρακολούθηση προόδου",
      "Προβολή αλόγων ιππόδρομου με όνομα και φωτογραφία",
      "Χωρίς πρόσβαση σε ιδιωτικά δεδομένα υγείας",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "Ανά μήνα · λειτουργικότητα ιππόδρομου συμπεριλαμβάνεται",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Γίνε μέλος",
      title: "Ξεκίνα ως ιππέας ιππόδρομου.",
      href: "/#waitlist",
    },
  },
  "manege-module": {
    slug: "manege-module",
    eyebrow: "Για ιππικές σχολές & στάβλους",
    title: "Κάντε την ιππική σχολή σας ψηφιακά προσβάσιμη σε κάθε αναβάτη.",
    subtitle: "Δώστε στους αναβάτες σύνδεση με άλογα, μαθήματα και πρόοδο — χωρίς να μοιράζεστε ευαίσθητα δεδομένα στάβλου.",
    primaryCTA: {
      label: "Ζητήστε πρόσβαση",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Δείτε τις ενότητες",
      href: "#features",
    },
    audience: "Το EquiSight βοηθά ιππικές σχολές και στάβλους να διατηρούν τους αναβάτες περισσότερο αφοσιωμένους και να ξεχωρίζουν ψηφιακά.",
    features: [
      "Προβολή αλόγων ιππικής σχολής στους αναβάτες",
      "Όνομα και φωτογραφία ανά άλογο",
      "Σύνδεση αναβατών με άλογα",
      "Πρόσβαση μόνο ανάγνωσης για ευαίσθητα δεδομένα",
      "Κεντρική καταγραφή ιστορικού μαθημάτων και εκπαίδευσης",
      "Διαχείριση χρηστών με ρόλους",
    ],
    benefits: [
      "Μεγαλύτερη αφοσίωση αναβατών",
      "Πιο επαγγελματική εικόνα",
      "Επιπλέον ψηφιακή υπηρεσία για μέλη",
      "Νέα ροή εσόδων μέσω χρήσης εφαρμογής",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "Ανά μήνα · λειτουργικότητα ιππικής σχολής συμπεριλαμβάνεται για αναβάτες",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Έτοιμοι;",
      title: "Ενεργοποιήστε την Ενότητα Ιππικής Σχολής.",
      href: "/#waitlist",
    },
  },
  "fokkerij": {
    slug: "fokkerij",
    eyebrow: "Μονάδα αναπαραγωγής",
    title: "Έλεγχος κύκλου, κύησης και ανάπτυξης πουλαριού.",
    subtitle: "Η πλήρης μονάδα αναπαραγωγής για ιδιοκτήτες φοράδων και αναπαραγωγείς — από τη σύζευξη έως το πουλάρι, σε ένα χρονολόγιο.",
    primaryCTA: {
      label: "Ενεργοποίηση Μονάδας Αναπαραγωγής",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Δείτε τις λειτουργίες",
      href: "#features",
    },
    audience: "Για αναπαραγωγείς, ιδιοκτήτες φοράδων και στάβλους που διαχειρίζονται πολλές φοράδες.",
    features: [
      "Παρακολούθηση κύκλου",
      "Καταγραφή οίστρου",
      "Καταχώριση δεδομένων σπερματέγχυσης",
      "Αντίστροφη μέτρηση για υπερηχογραφήματα",
      "Προγραμματισμός ελέγχων κύησης",
      "Γενεαλογικό δέντρο και καταγωγή",
      "Ανάπτυξη πουλαριού",
      "Επισκόπηση όλων των εγκύων φοράδων",
    ],
    pricing: {
      tiers: [
        {
          name: "Pro",
          price: "€14,99",
          note: "Ανά μήνα · Η μονάδα αναπαραγωγής συμπεριλαμβάνεται στο Pro",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Ξεκινήστε σήμερα",
      title: "Ξεκινήστε τη διαχείριση αναπαραγωγής.",
      href: "/#waitlist",
    },
  },
  "hoefsmid": {
    slug: "hoefsmid",
    eyebrow: "Μονάδα πεταλωτή",
    title: "Δουλέψτε πιο έξυπνα ως πεταλωτής. Καταγράψτε τα πάντα επαγγελματικά.",
    subtitle: "Ημερολόγιο, φωτογραφίες, σχόλια και ιστορικό θεραπείας σε μία μονάδα — λιγότερες παρεξηγήσεις, ισχυρότερος φάκελος.",
    primaryCTA: {
      label: "Ξεκινήστε ως πεταλωτής",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Δείτε το Professional Bundle",
      href: "/professional",
    },
    audience: "Για πεταλωτές που θέλουν να βελτιώσουν την οργάνωση, την τεκμηρίωση και την επικοινωνία με τους πελάτες.",
    features: [
      "Προσωπικό ημερολόγιο",
      "Ραντεβού ανά πελάτη",
      "Προβολή προφίλ αλόγων",
      "Προσθήκη φωτογραφιών πριν και μετά",
      "Καταγραφή θεραπείας",
      "Καταγραφή συμβουλών και σχολίων",
      "Ειδοποίηση ETA στον πελάτη: \"Ο πεταλωτής είναι καθ' οδόν\"",
    ],
    benefits: [
      "Πιο επαγγελματική εργασία",
      "Λιγότερες παρεξηγήσεις",
      "Καλύτερη δόμηση φακέλου",
      "Ισχυρότερη θέση σε περίπτωση ευθύνης",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "Ανά μήνα · Η μονάδα πεταλωτή περιλαμβάνεται στο Professional",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Έτοιμοι;",
      title: "Ενεργοποιήστε τη Μονάδα Πεταλωτή.",
      href: "/#waitlist",
    },
  },
  "paardentandarts": {
    slug: "paardentandarts",
    eyebrow: "Μονάδα οδοντιατρικής",
    title: "Ένας πλήρης οδοντιατρικός φάκελος ανά άλογο.",
    subtitle: "Καταγράψτε ευρήματα, θεραπείες και παρακολούθηση απευθείας στο EquiSight.",
    primaryCTA: {
      label: "Ξεκινήστε ως οδοντίατρος ίππων",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Δείτε το Professional Bundle",
      href: "/professional",
    },
    audience: "Οδοντίατροι ίππων, κτηνίατροι και κλινικές που θέλουν να εργάζονται με δομημένο τρόπο.",
    features: [
      "Καταγραφή οδοντικού ελέγχου",
      "Ευρήματα ανά θεραπεία",
      "Προσθήκη φωτογραφιών",
      "Αναφορά στον ιδιοκτήτη",
      "Συμβουλές παρακολούθησης",
      "Ιστορικό ανά άλογο",
      "Προγραμματισμός νέου ραντεβού",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "Ανά μήνα · Η μονάδα οδοντιατρικής συμπεριλαμβάνεται στο Professional",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Έτοιμοι;",
      title: "Ενεργοποιήστε τη Μονάδα Οδοντιατρικής.",
      href: "/#waitlist",
    },
  },
  "fysio-osteo": {
    slug: "fysio-osteo",
    eyebrow: "Μονάδα Φυσιο / Οστεο",
    title: "Παρακολουθήστε σώμα, κίνηση και αποκατάσταση επαγγελματικά.",
    subtitle: "Για φυσιοθεραπευτές και οστεοπαθητικούς που θέλουν να παρακολουθούν άλογα με δομημένο τρόπο.",
    primaryCTA: {
      label: "Ξεκινήστε ως φυσιο/οστεο",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Δείτε το Professional Bundle",
      href: "/professional",
    },
    features: [
      "Εισαγωγή ανά άλογο",
      "Καταγραφή σωματικών ευρημάτων",
      "Προσθήκη φωτογραφιών και βίντεο",
      "Δημιουργία έκθεσης θεραπείας",
      "Κοινοποίηση ασκήσεων και παρακολούθησης",
      "Παρακολούθηση πορείας αποκατάστασης",
      "Ιστορικό ανά άλογο",
    ],
    benefits: [
      "Καλύτερη κατανόηση με την πάροδο του χρόνου",
      "Επαγγελματική αναφορά",
      "Σαφής επικοινωνία με ιδιοκτήτη, εκπαιδευτή και αναβάτη",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "Ανά μήνα · Μονάδα Φυσιο / Οστεο συμπεριλαμβάνεται στο Professional",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Έτοιμοι;",
      title: "Ενεργοποιήστε τη Μονάδα Φυσιο / Οστεο.",
      href: "/#waitlist",
    },
  },
  "trainer": {
    slug: "trainer",
    eyebrow: "Μονάδα εκπαιδευτή",
    title: "Καθοδηγήστε αναβάτες με δεδομένα, στόχους και πρόοδο.",
    subtitle: "Κάντε την προπόνηση μετρήσιμη και την καθοδήγηση πιο επαγγελματική — για έναν ή περισσότερους αναβάτες.",
    primaryCTA: {
      label: "Ξεκινήστε ως εκπαιδευτής",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Δείτε το πακέτο Pro",
      href: "/#pricing",
    },
    audience: "Για εκπαιδευτές, προπονητές και coaches με πολλούς αναβάτες ή άλογα.",
    features: [
      "Σύνδεση αναβατών",
      "Παρακολούθηση αλόγων",
      "Ορισμός στόχων προπόνησης",
      "Παροχή ανατροφοδότησης",
      "Ανάλυση αποτελεσμάτων αγώνων",
      "Προβολή προόδου ανά συνδυασμό",
      "Χρήση αναλύσεων πρωτοκόλλου για εστίαση στην προπόνηση",
    ],
    benefits: [
      "Καλύτερη καθοδήγηση",
      "Περισσότερη δομή",
      "Πιο επαγγελματική επικοινωνία",
      "Μεγαλύτερη δέσμευση με τους πελάτες",
    ],
    pricing: {
      tiers: [
        {
          name: "Pro",
          price: "€14,99",
          note: "Ανά μήνα · Μονάδα εκπαιδευτή συμπεριλαμβάνεται στο Pro",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Έτοιμοι;",
      title: "Ενεργοποιήστε τη Μονάδα Εκπαιδευτή.",
      href: "/#waitlist",
    },
  },
  "wedstrijdanalyse": {
    slug: "wedstrijdanalyse",
    eyebrow: "Ανάλυση Αγώνων",
    title: "Από το πρωτόκολλο στη βελτίωση επίδοσης.",
    subtitle: "Ανέβασε το πρωτόκολλο αγώνα σου και ανακάλυψε πού χάνεις πόντους — όχι απλώς να βλέπεις το σκορ σου, αλλά να καταλαβαίνεις πώς θα γίνεις καλύτερος.",
    primaryCTA: {
      label: "Ανάλυσε το πρώτο σου πρωτόκολλο",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Δες το Premium",
      href: "/premium",
    },
    features: [
      "Ανέβασμα φωτογραφίας πρωτοκόλλου",
      "Επεξεργασία μπροστινής και πίσω πλευράς",
      "Αναγνώριση κλάσης, αριθμού δοκιμής και κριτή",
      "Ανάλυση βαθμών ανά ενότητα",
      "Σύνοψη σχολίων",
      "Εμφάνιση δυνατών και αδύναμων σημείων",
      "Τάσεις ανά συνδυασμό αλόγου-αναβάτη",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "Ανά μήνα · ανάλυση αγώνων συμπεριλαμβάνεται από το Premium",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Έτοιμος;",
      title: "Ξεκίνα με την ανάλυση αγώνων.",
      href: "/#waitlist",
    },
  },
  "professional": {
    slug: "professional",
    eyebrow: "Επαγγελματικό πακέτο",
    title: "Για επαγγελματίες γύρω από το άλογο.",
    subtitle: "Πεταλωτής, κτηνιατρικός οδοντίατρος, φυσιοθεραπευτής, οστεοπαθητικός ή εκπαιδευτής: συνεργαστείτε σε έναν ενιαίο ψηφιακό φάκελο αλόγου.",
    primaryCTA: {
      label: "Ξεκινήστε ως επαγγελματίας",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Δείτε τις επιμέρους ενότητες",
      href: "#features",
    },
    audience: "Το Επαγγελματικό Πακέτο συνδυάζει όλες τις επαγγελματικές ενότητες σε ένα ενιαίο συνδρομητικό πλάνο.",
    features: [
      "Ενότητα Πεταλωτή",
      "Ενότητα Κτηνιατρικής Οδοντιατρικής",
      "Ενότητα Φυσιοθεραπείας / Οστεοπαθητικής",
      "Ημερολόγιο & διαχείριση πελατών",
      "Προφίλ αλόγων & αναφορές",
      "Ιστορικό θεραπειών & δημιουργία φακέλου",
      "Επικοινωνία με τον ιδιοκτήτη",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "Ανά μήνα · όλες οι επαγγελματικές ενότητες συμπεριλαμβάνονται",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Έτοιμοι;",
      title: "Επιλέξτε το Professional.",
      href: "/#waitlist",
    },
  },
  "noodnummerpaard": {
    slug: "noodnummerpaard",
    eyebrow: "Αριθμοί έκτακτης ανάγκης αλόγου",
    title: "Πάντα η σωστή βοήθεια στα χέρια σου.",
    subtitle: "Σε μια έκτακτη ανάγκη κάθε δευτερόλεπτο μετράει. Με το EquiSight έχεις όλα τα σημαντικά στοιχεία επικοινωνίας για το άλογό σου άμεσα διαθέσιμα — ένα άγγιγμα και τηλεφωνείς.",
    primaryCTA: {
      label: "Ετοίμασε τις επαφές έκτακτης ανάγκης σου",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Ξεκίνα δωρεάν με το EquiSight",
      href: "/#waitlist",
    },
    accent: "danger",
    heroScreenshot: {
      url: "/assets/emergency.png",
      alt: "Επαφές έκτακτης ανάγκης — άμεση κλήση, WhatsApp ή πλοήγηση προς κτηνίατρο, κλινική και πεταλωτή",
      caption: "Ένα άγγιγμα. Χωρίς πανικό.",
      embeddedFrame: true,
    },
    problem: "Το άλογό σου έχει κάτι — κολικό, τραυματισμό, πανικό. Και τότε αρχίζει το ψάξιμο. Ποιον καλείς; Έχεις τον σωστό αριθμό; Είναι αυτός ο αριθμός έκτακτης ανάγκης; Πολύτιμος χρόνος χάνεται.",
    solution: "Με το EquiSight έχεις τα πάντα άμεσα στα χέρια σου. Χωρίς ψάξιμο. Χωρίς αμφιβολία. Ένα άγγιγμα και έχεις επαφή.",
    scenario: {
      title: "Φαντάσου — το άλογό σου εμφανίζει συμπτώματα κολικού.",
      steps: [
        "Ανοίγεις το EquiSight",
        "Πατάς «Κτηνίατρος»",
        "Τηλεφωνείς αμέσως",
      ],
      tagline: "Χωρίς άγχος. Χωρίς ψάξιμο. Μόνο δράση.",
    },
    features: [
      "Όλοι οι αριθμοί έκτακτης ανάγκης σε ένα μέρος",
      "Κλήση με ένα άγγιγμα μέσα από την εφαρμογή",
      "WhatsApp με ένα άγγιγμα",
      "Άμεση πλοήγηση στη διεύθυνση",
      "Ξεχωριστή λίστα επαφών για κάθε άλογο",
      "Κτηνίατρος, κλινική, πεταλωτής, οδοντίατρος, φυσιοθεραπευτής",
      "Διεύθυνση + οδηγίες πλοήγησης άμεσα διαθέσιμες",
      "Σήμανε αγαπημένους αριθμούς με αστέρι",
      "Αριθμοί έκτακτης ανάγκης (112, 144) πάντα στην κορυφή",
    ],
    benefits: [
      "Ηρεμία και έλεγχος σε κατάσταση έκτακτης ανάγκης",
      "Όλοι στο στάβλο έχουν τους ίδιους αριθμούς διαθέσιμους",
      "Δεν ξεχνάς πια επαγγελματικές κάρτες",
      "Αντιδράς δευτερόλεπτα γρηγορότερα σε επείγουσες καταστάσεις",
    ],
    audience: "Για ιδιοκτήτες αλόγων, φροντιστές, εκπαιδευτές και στάβλους — όλους όσους είναι υπεύθυνοι για ένα άλογο.",
    showcase: {
      eyebrow: "Προεγκατεστημένο για σένα",
      title: "13 κατηγορίες επαφών — έτοιμες για συμπλήρωση.",
      description: "Από κτηνίατρο και κλινική επειγόντων έως σελοποιό, εκπαιδευτή και διαχειριστή βοσκότοπου. Το EquiSight γνωρίζει τον κόσμο σου και έχει ήδη ετοιμάσει τα κατάλληλα πεδία επαφών. Άγγιξε, συμπλήρωσε, έτοιμο.",
      bullets: [
        "Έκτακτη ανάγκη & υγεία — κτηνίατρος, επείγοντα, κλινική, γραμμή δηλητηρίασης",
        "Καθημερινή φροντίδα — πεταλωτής, οδοντίατρος, φυσιοθεραπευτής, εκπαιδευτής",
        "Στάβλος & βοσκότοπος — σταβλάρχης, διαχειριστής βοσκότοπου, πανσιόν",
        "Τροφή & εξοπλισμός — προμηθευτές σανού, συμπυκνωμένης τροφής, άχυρου",
      ],
      image: {
        url: "/assets/emergency-manage.png",
        alt: "Οθόνη διαχείρισης επαφών έκτακτης ανάγκης — όλες οι προτεινόμενες επαφές ανά κατηγορία",
        embeddedFrame: true,
      },
    },
    checklist: {
      title: "Λίστα ελέγχου αριθμών έκτακτης ανάγκης αλόγου",
      items: [
        "Κτηνίατρος",
        "Κλινική επειγόντων (24/7)",
        "Ασθενοφόρο ζώων · 144",
        "Πεταλωτής",
        "Εφεδρική επαφή",
        "Γενικός αριθμός έκτακτης ανάγκης · 112",
      ],
      cta: {
        label: "Άνοιξε στο EquiSight και συμπλήρωσε αμέσως",
        href: "/#waitlist",
      },
    },
    pricing: {
      tiers: [
        {
          name: "Αριθμοί έκτακτης ανάγκης",
          price: "Gratis",
          note: "Πάντα δωρεάν · για όλους, σε κάθε συνδρομή",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Φρόντισε να είσαι προετοιμασμένος",
      title: "Πριν χρειαστεί.",
      href: "/#waitlist",
    },
    microcopy: [
      "Χωρίς δεσμεύσεις",
      "Ρύθμιση σε λιγότερο από 2 λεπτά",
      "Πάντα επεξεργάσιμο",
    ],
  },
};

export default LANDINGS;
